import { render, staticRenderFns } from "./PlaylistStart.vue?vue&type=template&id=70b7c049"
import script from "./PlaylistStart.vue?vue&type=script&lang=js"
export * from "./PlaylistStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports